import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex);

let store = new Vuex.Store({
    state:{
        action: localStorage.getItem("action"), // 检索from
        name: localStorage.getItem('name'), // 检索from name
        userName: localStorage.getItem('userName'), // 检索from name
        menu: null,//menu 对象
        loding: false, //进度条开关
        token: localStorage.getItem('token'), //
        msflag: true,
        loginFlag: 0,
        // @ts-ignore
        getMarkList: 1, //导航数据
        time: localStorage.getItem('time'),// 更新时间戳
    },
    mutations:{
        setAction(state,a){
            state.action = a;
        },
        setMsFlag(state,a){
            state.msflag = a;
        },
        setToken(state,tk){
            state.token = tk;
            localStorage.setItem("token", tk);
        },
        setName(state,item){
            state.name = item;
            localStorage.setItem("name", item);
        },
        setUserName(state,item){
            state.userName = item;
            localStorage.setItem("userName", item);
        },
        setMenu(state,imenu){
            state.menu = imenu
        },
        getMarkList(state){
            state.getMarkList = state.getMarkList + 1;
        },
        setTime(state,item){
            state.time = item;
            localStorage.setItem('time',item)
        },
        lodingStrat(state){
            state.loding = true;
        },
        lodingEnd(state){
            state.loding = false;
        },
        // 通过修改loginFlag打开loginDialog
        openLogin(state,item){
            if(state.loginFlag == item){
                state.loginFlag = 9;
                setTimeout(() => {
                    state.loginFlag = item;     
                }, 10);
            } else { 
                state.loginFlag = item;
            }
            
        }
    }
});

export default store;
